import * as React from "react";
import classnames from "classnames";
import { Icon } from "@grandvisionhq/icons";
/* empty css                            */
const AppointmentTypeToolTip = ({ className, tabIndex = 0, ...rest }) => {
  return /* @__PURE__ */ React.createElement(
    "span",
    {
      ...rest,
      className: classnames("appointment-type-tooltip", className),
      role: "button",
      tabIndex
    },
    /* @__PURE__ */ React.createElement("span", { className: "appointment-type-tooltip__icon-container" }, /* @__PURE__ */ React.createElement(Icon, { name: "info" }))
  );
};
export {
  AppointmentTypeToolTip,
  AppointmentTypeToolTip as default
};
//# sourceMappingURL=AppointmentTypeToolTip.js.map
